export enum EmptyLegsTabKeysEnum {
  ACTIVE = 'active',
  ARCHIVE = 'archive',
}
